<template>
  <v-toolbar extended flat>
    <v-toolbar-title>{{ title }}</v-toolbar-title>
    <v-divider class="mx-4" inset vertical/>
    <v-text-field single-line
                  hide-details
                  :placeholder="t({s: 'search', component: 'general'})"
                  flat v-model="search"
                  :color="$vuetify.theme.isDark ? 'secondary' : 'primary'"
                  append-icon="fa fa-search"
                  style="max-width: 250px;"
    />
    <div class="mx-4" v-if="total">
      {{ `${total} ${t({s: 'total', component: 'general'})}` }}
    </div>
    <div v-if="flexGrow" class="flex-grow-1"></div>
    <slot />
  </v-toolbar>
</template>

<script>

import Vue from 'vue'
export default Vue.extend({
  name: 'DataTableToolbar.vue',
  props: {
    title: String,
    total: Number,
    flexGrow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      search: ''
    }
  },
  watch: {
    search (val) {
      this.$emit('search', val)
    }
  },
  mounted () {
    if (this.$route.query.search) {
      this.search = this.$route.query.search
    }
  }
})
</script>
